import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Location } from 'history';

export const ROUTING_REDUCER_NAME = 'routing';

export interface RoutingState {
  location: Location | null;
  previousLocation: Location | null;
}

const initialState: RoutingState = {
  location: null,
  previousLocation: null,
};

export const routingSlice = createSlice({
  name: ROUTING_REDUCER_NAME,
  initialState,
  reducers: {
    locationChanged: (draft, action: PayloadAction<Location>) => {
      draft.previousLocation = draft.location;
      draft.location = action.payload;
    },
  },
});

export const { locationChanged } = routingSlice.actions;

export default routingSlice.reducer;
